import get from "lodash/get";
import set from "lodash/set";
import { parseDate } from "chrono-node";
import { DATE_FORMATS } from "../../constants";

const { DATE_PICKER_FORMAT } = DATE_FORMATS;

function updateUnits(obj, preferred) {
  if (!("_dates" in obj)) return;
  const keys = obj._dates;
  delete obj._dates;
  if (!Array.isArray(keys)) return;

  // Go over dates and parse them from plain text into js dates.
  keys.forEach((key) => {
    const value = parseDate(get(obj, key), "") || "";
    set(obj, key, value);

    if (process.browser) {
      // Update the input in the browser.
      const input = document.querySelector(`[name="${key}"]`);
      if (input)
        input.value = value && this.momentTZ(value).format(DATE_PICKER_FORMAT);
    }
  });

  return obj;
}

export default updateUnits;
